import { z } from 'zod';
const NotificationPrioritySchema = z.enum(['do_not_send', 'batch', 'immediate']);
const OptionalNotificationPrioritySchema = NotificationPrioritySchema.optional();
export const NotificationSettingsSchema = z.object({
    new_message_in_thread_priority: OptionalNotificationPrioritySchema,
    new_message_in_thread_with_mention_priority: OptionalNotificationPrioritySchema,
    new_message_in_thread_connected_to_my_task_priority: OptionalNotificationPrioritySchema,
    new_message_in_thread_connected_to_task_priority: OptionalNotificationPrioritySchema,
    new_task_assignee_in_my_task_priority: OptionalNotificationPrioritySchema,
    order_blocked_priority: OptionalNotificationPrioritySchema,
    valuation_finalised_priority: OptionalNotificationPrioritySchema,
    order_accepted_priority: OptionalNotificationPrioritySchema,
    new_order_due_date_priority: OptionalNotificationPrioritySchema,
    new_inspection_date_priority: OptionalNotificationPrioritySchema,
    task_created_priority: OptionalNotificationPrioritySchema,
    my_task_status_transitioned_priority: OptionalNotificationPrioritySchema,
    task_status_transitioned_priority: OptionalNotificationPrioritySchema,
    task_due_tomorrow_priority: OptionalNotificationPrioritySchema,
    task_due_soon_priority: OptionalNotificationPrioritySchema,
    order_document_attached_priority: OptionalNotificationPrioritySchema,
    order_status_transitioned_priority: OptionalNotificationPrioritySchema,
    draft_valuation_created_priority: OptionalNotificationPrioritySchema,
    plausibility_handed_over_priority: OptionalNotificationPrioritySchema,
    plausibility_approved_priority: OptionalNotificationPrioritySchema,
    plausibility_internally_approved_priority: OptionalNotificationPrioritySchema,
    plausibility_new_message_priority: OptionalNotificationPrioritySchema,
    plausibility_edited_message_priority: OptionalNotificationPrioritySchema,
    plausibility_deleted_message_priority: OptionalNotificationPrioritySchema,
    value_check_finalised_priority: OptionalNotificationPrioritySchema,
});
